import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { ReportModel, CustomerModel } from '../../../domain/models'
import {
  fetchCustomer,
  fetchReport,
  resetReport,
  saveReport,
  updateReport
} from '../../../main/usecases'

import { maskCpf, formatDate } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import {
  Button,
  EditorCard,
  ServicesHeader,
  SubHeader,
  ResetModal
} from '../../components'

import {
  IconSaveSvg,
  IconReturnSvg,
  PrinterSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

const Reports = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [report, setReport] = useState<ReportModel>()
  const [reportData, setReportData] = useState('')
  const [loading, setLoading] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)
  const alert = useAlert()
  const { modalBox } = useModalBox()
  const { refresh, setRefresh } = useOnChangeDetect()

  const handleOpenResetModal = () => {
    modalBox(
      <ResetModal
        id={match?.params?.idassessment}
        loading={resetLoading}
        resetDocument={resetReport}
        setDocument={setReport}
        setDocumentData={setReportData}
        document="laudo"
      />,
      'Resetar Laudo',
      '32%'
    )
  }

  const onSaveReport = async () => {
    const body = {
      ...(report?.cdLaudo && {
        cdLaudo: report?.cdLaudo
      }),
      laudo: reportData
    }

    try {
      setResetLoading(true)
      if (report?.cdLaudo) {
        await updateReport({
          id: match?.params?.idassessment
        }).update(body)
        setRefresh((prev: any) => !prev)
      } else {
        await saveReport({
          id: match?.params?.idassessment
        }).post(body)
        setRefresh((prev: any) => !prev)
      }
      setResetLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handlePrinter = async () => {
    const body = {
      ...(report?.cdLaudo && {
        cdLaudo: report?.cdLaudo
      }),
      laudo: reportData
    }

    try {
      if (report?.cdLaudo) {
        await updateReport({
          id: match?.params?.idassessment
        }).update(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      } else {
        await saveReport({
          id: match?.params?.idassessment
        }).post(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    window.onafterprint = function () {
      document
        ?.querySelectorAll('[style="display:none !important;"]')[0]
        ?.setAttribute('style', 'display: block !important;')
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      try {
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        const responseReport = await fetchReport({
          id: match?.params?.idassessment
        }).load()
        setCustomer(responseCustomer)
        setReport(responseReport)
        setReportData(responseReport?.laudo)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match.params.id, match?.params?.idassessment, refresh])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      ...(report?.cdLaudo && {
        cdLaudo: report?.cdLaudo
      }),
      laudo: reportData
    }

    try {
      setLoading(true)
      if (report?.cdLaudo) {
        await updateReport({
          id: match?.params?.idassessment
        }).update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      } else {
        await saveReport({
          id: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Error ao salvar/atualizar o Laudo', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1500)
    }
  }

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match.params.id}/prontuario?serviceId=${match.params.idservico}`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          title="Laudo"
          hasPrinter
          disabled={loading}
          onPrinter={handlePrinter}
        />
        <EditorCard
          data={report && report?.laudo}
          setData={setReportData}
          title=""
          height="auto"
          hasReset
          openResetModal={() => {
            onSaveReport()
            handleOpenResetModal()
          }}
        />
        <S.ButtonsContainer className="no-print">
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            onClick={onSubmit}
            disabled={loading}
          >
            Salvar
          </Button>
          <Button
            initialIcon={<PrinterSvg />}
            className="button-printer"
            onClick={handlePrinter}
          >
            Imprimir
          </Button>
          <Button
            initialIcon={<IconReturnSvg />}
            hasSecodaryButton
            className="button-return-to-list"
          >
            <Link to={`/meus-pacientes/${match?.params?.id}/prontuario`}>
              Retornar à listagem
            </Link>
          </Button>

          {report?.dataUltimaModificacao && (
            <p>
              Data da última atualização:{' '}
              {formatDate(report?.dataUltimaModificacao || '')}
            </p>
          )}
        </S.ButtonsContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Reports
